import { render, staticRenderFns } from "./OptionButtons.vue?vue&type=template&id=5a124a7b"
import script from "./OptionButtons.vue?vue&type=script&lang=js"
export * from "./OptionButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports